import { render, staticRenderFns } from "./contraband.vue?vue&type=template&id=72d9ef0f&scoped=true&"
import script from "./contraband.vue?vue&type=script&lang=ts&"
export * from "./contraband.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d9ef0f",
  null
  
)

export default component.exports